// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2MTsE","Open":"SideDrawer_Open__15p45","Close":"SideDrawer_Close__3SOpw","Logo":"SideDrawer_Logo__2w-Ch"};